import React from 'react'
import { connect } from 'react-redux'
import { nullDate } from '../../public/utility'
import TreeSelect from 'tyan/business/TreeSelect'
import { hasChangedValues, getFormValue, changeItemsValue, getListFromValues } from 'tyan/public/utility'

class AnnouncementDetail extends React.Component {
    state = {
        changedValues基本信息: {},
    }
    componentDidMount = () => {
        const { id } = this.props
        this.doGetAnnouncement(id)
    }
    
    SettingsDiv = {
		'分类': TreeSelect,
	}

    doGetAnnouncement = (id) => {
        Tyan.doPostEvent({
            event: 'GetAnnouncement',
            data: { id },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
            }
        })
    }

    handlerSave = () => {
        const { id, changedValues基本信息 } = this.state
        Tyan.doPostEvent({
            event: 'SaveAnnouncement',
            data: { id, changedValues基本信息 },
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                Ext.toast('保存成功')
                this.doGetAnnouncement(id)
            }
        })
    }

    handlerDelete = () => {
        const { onClose, onSave } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteAnnouncement',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    Ext.toast('删除成功')
                    onSave && onSave()
                    onClose && onClose()
                }
            }))
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const 生效日期 = getFormValue(this, '基本信息', '生效日期')
        const 等级 = getFormValue(this, '基本信息', '等级')
        return this.bChanged() && 生效日期 && 生效日期 != nullDate && 等级
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    fieldset基本信息 = () => {
        const { optionsParas: { obj分类 }, initValues基本信息, changedValues基本信息 } = this.state
        const { list: optionsList } = getListFromValues('公告范围', null, obj分类, {})
        console.log('optionsList2',optionsList)
        return [
            { _text: '公告编号', minWidth: '95%', disabled: true },
            { _text: '公告标题', minWidth: '95%', },
            { _text: '公告内容', minWidth: '95%', maxRows: 5, richtext: true, fontSize:'18px' },
            { _files: '附件', minWidth: '95%', },
            { _date: '生效日期', minWidth: '45%', required: true },
            { _date: '失效日期', minWidth: '45%', },
            { _text: '发布人', minWidth: '45%', disabled: true },
            { _radio: '等级', minWidth: '45%' },
            // { _checkbox: '公告范围', minWidth: '95%', },
            {
				_treeselect2: '公告范围', name: '公告范围', required: true, displayField: '所属分类', options: optionsList,
				displayFull: '/', fullNameField: 'fullName', multiSelect: true
			},
        ]
    }

    fieldset已读人员 = () => {
        return [{
            _grid: '', name: '已读人员', rowNumbers: true, /*minRows: 3, maxRows: 11, */ height: '100%',
            columns: [
                { _text: '人员', flex: 1 },
                { _datetime: '时间', flex: 1 },
            ],
            buttons: [
            ],
        }]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, id, initValues基本信息, } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this}
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '公告', name: '基本信息', _fieldset: this.fieldset基本信息(), docked: 'left', width: '65%', },
                    { title: '已读人员', name: '基本信息', _fieldset: this.fieldset已读人员(), fullblock: true },
                ]
            }
        />
    }
}

export default connect()(AnnouncementDetail)